module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMi40NCIgaGVpZ2h0PSIxOC42NTUiIHZpZXdCb3g9IjAgMCAzMi40NCAxOC42NTUiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgICAgc3Ryb2tlOiAjNzM2YzZjOwogICAgICAgIHN0cm9rZS13aWR0aDogMnB4OwogICAgICAgIGZpbGwtcnVsZTogZXZlbm9kZDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHBhdGggaWQ9IkFycm93IiBjbGFzcz0iY2xzLTEiIGQ9Ik0xMDM4LjIzLDEwMDAuNzlMMTAyMywxMDE2LjAybC0xNS4yMy0xNS4yMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwMDYuNzggLTk5OC4zNzUpIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-down.svg
// module id = zpNP
// module chunks = 1